import fr from './locales/fr.json';
import en from './locales/en.json';
import moment from 'moment/moment';

import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const getCookieSelectedLang = () => {
    let cookieLocale = "fr";

    try {
        cookieLocale = document.cookie && document.cookie.indexOf('locale=') !== -1 ? document.cookie.split('locale=')[1].split(';')[0] : '';
    } catch (e) {
        console.log(e)
    }
    if (cookieLocale) {
        return cookieLocale;
    }
    return null;
};

const getBrowserDefaultLang = () => {
    if (navigator.languages !== undefined) {
        return navigator.languages[0].slice(0,2);
    }
    return navigator.language.slice(0,2);
};

const getDefaultLang = () => {
    const selectedLang = getCookieSelectedLang();
    if (selectedLang) {
        return selectedLang;
    } else {
        const browserDefaultLang = getBrowserDefaultLang();
        return browserDefaultLang === 'fr' || browserDefaultLang === 'en' ? browserDefaultLang : 'fr'
    }
};

const setLangCookie = (lang) => {
    document.cookie = `locale=${lang}; path=/`;
};

export const checkEmptyTranslation = (value) => {
    if(value === null || value === '' || value === undefined) {
        return 'Cette traduction est vide'
    }
    return value;
}

export const setLang = (lang) => {
    moment.locale(lang);
    document.documentElement.lang = lang;
    setLangCookie(lang);
}

setLang(getDefaultLang());

export default new VueI18n({
    locale: getDefaultLang(),
    fallbackLocale: 'fr',
    escapeParameterHtml: false,
    messages: {
        fr,
        en,
    }
})
